<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate *ngIf="!esDetalle">
    <div class="grid form-group flex align-items-center">
      <!-- NUMERO DE CUOTAS -->
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label
            >* {{ "PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS" | translate }}</label
          >
          <input
            type="text"
            pInputText
            id="idCuotas"
            name="nomNumeroCuota"
            autocomplete="off"
            formControlName="numeroCuotas"
            [maxlength]="3"
            numero-entero-reactive
          />
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.numeroCuotas.invalid"
          >
            {{ "PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="numeroCuotasExiste"
          >
            {{ "PRODUCTOFRECUENCIA.LBL_VALOREXISTE" | translate }}
          </div>
        </div>
      </div>
      <!-- BOTON  AGRECAR -->
      <div class="col-12 md:col-6 lg:col-6 mt-3">
        <div class="div-form">
          <button
            icon="fa fa-plus"
            label="{{ 'BTN_AGREGAR' | translate }}"
            type="submit"
            pButton
          ></button>
        </div>
      </div>
    </div>
  </form>

  <!-- LISTADO DE INSUMOS AGRICOLAS -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #dt
        [value]="lisProductosFrecuenciasCuotas"
        selectionMode="single"
        dataKey="idProductosFrecuenciasCuotas"
        [paginator]="true"
        [rows]="4"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row">
            <td class="table-break">{{ rowIndex + 1 }}</td>
            <td class="table-break">{{ row.numeroCuotas }}</td>
            <td class="text-center">
              <div class="btn-group" role="group" *ngIf="!esDetalle">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhabilitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button
        icon="fa fa-arrow-left"
        label="{{ 'BTN_REGRESAR' | translate }}"
        type="button"
        pButton
        (click)="cerrar()"
      ></button>
    </div>
  </div>
</div>
